module.exports = __webpack_public_path__ + "static/img/1042_big.f82818b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1042_big.png
// module id = Do5H
// module chunks = 1